export default __webpack_public_path__ + "static/1-a6335913f5529c286bfdd9ee2c40b860.jpg";